import React, { useState, forwardRef, useRef } from "react";
import {
  DialogContent,
  DialogTitle,
  Dialog,
  Paper,
  TextField,
  Box,
  Grid,
  Typography,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  Button,
  IconButton,
  TableRow,
  TableBody,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import EditIcon from "@mui/icons-material/Edit";
import ReactToPrint, {
  PrintContextConsumer,
  useReactToPrint,
} from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import {
  BootstrapDialog,
  BootstrapDialogTitle,
} from "../../reusableComponent/BootstrapDialog";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/StyledTable";
import styles from ".././../../styles.module.css";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import Customer_Supplier_PaymentAdd from "../../payments/Customer_Supplier_PaymentAdd";
import RemarksSection from "../../reusableComponent/RemarksSection";
import ProformaInvoicePrint from "./ProformaInvoicePrint";
import ProformaInvoiceAdd from "./ProformaInvoiceAdd";

const ComponentToPrintRow = forwardRef((props, ref) => {
  const {
    value,
    invoicePrintTitleDetails,
    printSetupDetails,
    invoiceSettingList,
  } = props;
  return (
    <div className="print-source" ref={ref}>
      <ProformaInvoicePrint
        pEntryPrint={value}
        invoicePrintTitleDetails={invoicePrintTitleDetails}
        printSetupDetails={printSetupDetails}
        invoiceSettingList={invoiceSettingList}
      />
    </div>
  );
});

const ComponentToPrintPEntryWrapper = ({
  pEntryPrint,
  invoicePrintTitleDetails,
  printSetupDetails,
  invoiceSettingList,
}) => {
  const ref = useRef();

  return (
    <div style={{ display: "flex" }}>
      <ReactToPrint
        trigger={() => (
          <Icon icon="flat-color-icons:print" width="21" height="20" />
        )}
        content={() => ref.current}
      />
      <div style={{ display: "none" }}>
        <ComponentToPrintRow
          ref={ref}
          value={pEntryPrint}
          invoicePrintTitleDetails={invoicePrintTitleDetails}
          printSetupDetails={printSetupDetails}
          invoiceSettingList={invoiceSettingList}
        />
      </div>
    </div>
  );
};

const ProformaInvoiceDetails = (props) => {
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  const termsList = props.termsList;
  const navigate = useNavigate();
  const detailsView = props.details;
  const invoicePrintTitleDetails = props.invoicePrintTitleDetails;
  const printSetupDetails = props.printSetupDetails;
  const invoiceSettingList =
    props.invoiceSettingList && props.invoiceSettingList;

  const invoiceSetting =
    props.invoiceSettingList && props.invoiceSettingList[0];

  const termsDetails =
    detailsView.invoice_terms && JSON.parse(detailsView.invoice_terms);

  const [open, setOpen] = useState(false);
  const [openOption, setOpenOption] = useState("");
  const dateConversion = (date) => {
    var today = new Date(date);
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    const convDate = dd + "/" + mm + "/" + yyyy;
    return convDate;
  };
  const handleClose = (event, reason) => {
    setOpen(false);
  };
  const handleClickOpenPopup = (info) => {
    // setInfo(info);
    setOpen(true);
    setOpenOption("Update");
  };
  const handlePayment = (info) => {
    // setInfo(info);
    setOpen(true);
    setOpenOption("Payment");
  };
  const navigateToAddEdit = (row) => {
    const state = {
      row,
      invoiceSettingList,
      termsList,
    };
    navigate("/sales/add-proforma-invoice", { state });
  };
  const navigateToPayment = (row) => {
    const state = {
      row,
    };
    navigate("/sales/customer-payment", { state });
  };
  const navigateToLink = (row, url) => {
    if (url === "SP") {
      const state = {
        row: undefined,
        prName: {
          CNS_Name: row.CNS_Name,
          CSNId: row.CSNId,
          emailId: row.emailId,
          gstn: row.gstn,
          address: row.address,
          pinCode: row.pinCode,
          state: row.state,
        },
      };
      navigate("/purchase/supplier-payment", { state });
    } else {
      const state = {
        row: undefined,
        prName: {
          CNS_Name: row.CNS_Name,
          CSNId: row.CSNId,
          emailId: row.emailId,
          gstn: row.gstn,
          address: row.address,
          pinCode: row.pinCode,
          state: row.state,
        },
      };
      navigate("/sales/customer-payment", { state });
    }
  };

  return (
    <>
      <Paper sx={{ boxShadow: "none" }}>
        <Box display="flex" flexDirection="column">
          <Box>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item md={10}>
                <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Customer Name
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {detailsView.customerName == null
                        ? "-"
                        : detailsView.CNS_Name}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Invoice No
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {detailsView.invoiceNo}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Invoice Date
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {dateConversion(detailsView.invoiceDate)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Challan No
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {" "}
                      {detailsView.challanNo == ""
                        ? "-"
                        : detailsView.challanNo}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Challan Date{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {detailsView.challanNo == ""
                        ? "-"
                        : dateConversion(detailsView.challanDate)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Order Ref. No
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {" "}
                      {detailsView.orderRefNo == ""
                        ? "-"
                        : detailsView.orderRefNo}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography className={`${styles.detail_lable}`}>
                      Order Ref. Date
                    </Typography>
                  </Grid>
                  <Grid item xs={0.4}>
                    <Typography className={`${styles.detail_lable}`}>
                      :{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={9.5}>
                    <Typography className={`${styles.erp_lable}`}>
                      {detailsView.orderRefNo == ""
                        ? "-"
                        : dateConversion(detailsView.orderRefDate)}
                    </Typography>
                  </Grid>
                  {invoiceSetting.showAccountName === "true" && (
                    <>
                      <Grid item xs={2}>
                        <Typography className={`${styles.detail_lable}`}>
                          Account Manager Name
                        </Typography>
                      </Grid>
                      <Grid item xs={0.4}>
                        <Typography className={`${styles.detail_lable}`}>
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={9.5}>
                        <Typography className={`${styles.erp_lable}`}>
                          {detailsView.accountManagerName == ""
                            ? "-"
                            : detailsView.accountManagerName}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {invoiceSetting.showEWayBillNo === "true" && (
                    <>
                      <Grid item xs={2}>
                        <Typography className={`${styles.detail_lable}`}>
                          E-Way Bill No
                        </Typography>
                      </Grid>
                      <Grid item xs={0.4}>
                        <Typography className={`${styles.detail_lable}`}>
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={9.5}>
                        <Typography className={`${styles.erp_lable}`}>
                          {detailsView.eWayBillNo == ""
                            ? "-"
                            : detailsView.eWayBillNo}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {invoiceSetting.showTransportMode === "true" && (
                    <>
                      <Grid item xs={2}>
                        <Typography className={`${styles.detail_lable}`}>
                          Mode of Transport
                        </Typography>
                      </Grid>
                      <Grid item xs={0.4}>
                        <Typography className={`${styles.detail_lable}`}>
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={9.5}>
                        <Typography className={`${styles.erp_lable}`}>
                          {detailsView.modeOfTransport == ""
                            ? "-"
                            : detailsView.modeOfTransport}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {invoiceSetting.showVehicleNo === "true" && (
                    <>
                      <Grid item xs={2}>
                        <Typography className={`${styles.detail_lable}`}>
                          Vehicle No
                        </Typography>
                      </Grid>
                      <Grid item xs={0.4}>
                        <Typography className={`${styles.detail_lable}`}>
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={9.5}>
                        <Typography className={`${styles.erp_lable}`}>
                          {detailsView.vehicleNo == ""
                            ? "-"
                            : detailsView.vehicleNo}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {invoiceSetting.showPaymentTerms === "true" && (
                    <>
                      <Grid item xs={2}>
                        <Typography className={`${styles.detail_lable}`}>
                          Payment Terms
                        </Typography>
                      </Grid>
                      <Grid item xs={0.4}>
                        <Typography className={`${styles.detail_lable}`}>
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={9.5}>
                        <Typography className={`${styles.erp_lable}`}>
                          {detailsView.paymentTerms == ""
                            ? "-"
                            : detailsView.paymentTerms}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {invoiceSetting.showContactPerson === "true" && (
                    <>
                      <Grid item xs={2}>
                        <Typography className={`${styles.detail_lable}`}>
                          Contact Person
                        </Typography>
                      </Grid>
                      <Grid item xs={0.4}>
                        <Typography className={`${styles.detail_lable}`}>
                          :
                        </Typography>
                      </Grid>
                      <Grid item xs={9.5}>
                        <Typography className={`${styles.erp_lable}`}>
                          {detailsView.contactPerson == ""
                            ? "-"
                            : detailsView.contactPerson}
                        </Typography>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
              <Grid item md={2}>
                <Box>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      md={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Box sx={{ marginBottom: "6px" }}>
                        <Box sx={{ display: "flex", justifyContent: "right" }}>
                          <EditIcon
                            style={{
                              float: "left",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => navigateToAddEdit(detailsView)}
                          />
                        </Box>
                        <Box>
                          <a href="mailto:sales@onenetindia.com">
                            {" "}
                            <Icon
                              icon="clarity:email-line"
                              width="19"
                              height="19"
                              color="red"
                            />{" "}
                          </a>
                        </Box>
                        <Box>
                          <ComponentToPrintPEntryWrapper
                            key={detailsView._id}
                            pEntryPrint={detailsView}
                            invoicePrintTitleDetails={invoicePrintTitleDetails}
                            printSetupDetails={printSetupDetails}
                            invoiceSettingList={invoiceSettingList}
                          />
                        </Box>
                        {/* <Box>
                          <PaymentsOutlinedIcon
                            className={`${styles.underline}`}
                            onClick={() => navigateToPayment()}
                          />
                        </Box> */}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            <TableContainer
              component={Paper}
              style={{ overflowY: "auto", maxHeight: 140 }}
            >
              <Table sx={{ minWidth: 700 }} size="small" stickyHeader>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell
                      align="left"
                      sx={{ fontWeight: "bold" }}
                      className={`${styles.table_head}`}
                    >
                      Item Description
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      sx={{ fontWeight: "bold" }}
                      className={`${styles.table_head}`}
                    >
                      HSN Code
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      sx={{ fontWeight: "bold" }}
                      className={`${styles.table_head}`}
                    >
                      Quantity
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      sx={{ fontWeight: "bold" }}
                      className={`${styles.table_head}`}
                    >
                      Unit
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      sx={{ fontWeight: "bold" }}
                      className={`${styles.table_head}`}
                    >
                      Rate
                    </StyledTableCell>
                    {invoiceSetting.showNoOfPKG === "true" && (
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: "bold" }}
                        className={`${styles.table_head}`}
                      >
                        No of PKG
                      </StyledTableCell>
                    )}
                    {invoiceSetting.showBatchNo === "true" && (
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: "bold" }}
                        className={`${styles.table_head}`}
                      >
                        Batch No
                      </StyledTableCell>
                    )}
                    {invoiceSetting.showDiscountPer_details === "true" && (
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: "bold" }}
                        className={`${styles.table_head}`}
                      >
                        Discount %
                      </StyledTableCell>
                    )}
                    {invoiceSetting.showDiscountPer_details === "true" && (
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: "bold" }}
                        className={`${styles.table_head}`}
                      >
                        Discount Amt
                      </StyledTableCell>
                    )}
                    {invoiceSetting.showGstPer_details === "true" && (
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: "bold" }}
                        className={`${styles.table_head}`}
                      >
                        GST %
                      </StyledTableCell>
                    )}
                    {invoiceSetting.showGstPer_details === "true" && (
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: "bold" }}
                        className={`${styles.table_head}`}
                      >
                        GST Amt
                      </StyledTableCell>
                    )}
                    <StyledTableCell
                      align="center"
                      sx={{ fontWeight: "bold" }}
                      className={`${styles.table_head}`}
                    >
                      Amount
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {JSON.parse(detailsView && detailsView.childRows).map(
                    (row, index) => (
                      <>
                        <StyledTableRow key={row.id}>
                          <StyledTableCell
                            align="left"
                            className={`${styles.list_table_body}`}
                          >
                            {invoiceSetting.itemThroughManualEntry === "true"
                              ? row.itemDescription
                              : row.itemName + " (" + row.itemCode + ")"}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {row.hsnCode}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {row.quantity}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {row.unit}
                          </StyledTableCell>
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {row.rate}
                          </StyledTableCell>
                          {invoiceSetting.showNoOfPKG === "true" && (
                            <StyledTableCell
                              align="center"
                              className={`${styles.list_table_body}`}
                            >
                              {row.noOfPkg}
                            </StyledTableCell>
                          )}
                          {invoiceSetting.showBatchNo === "true" && (
                            <StyledTableCell
                              align="center"
                              className={`${styles.list_table_body}`}
                            >
                              {row.batchNo}
                            </StyledTableCell>
                          )}
                          {invoiceSetting.showDiscountPer_details ===
                            "true" && (
                            <StyledTableCell
                              align="center"
                              className={`${styles.list_table_body}`}
                            >
                              {row.discountPer}
                            </StyledTableCell>
                          )}
                          {invoiceSetting.showDiscountPer_details ===
                            "true" && (
                            <StyledTableCell
                              align="center"
                              className={`${styles.list_table_body}`}
                            >
                              {parseFloat(row.discountAmt).toFixed(2)}
                            </StyledTableCell>
                          )}
                          {invoiceSetting.showGstPer_details === "true" && (
                            <StyledTableCell
                              align="center"
                              className={`${styles.list_table_body}`}
                            >
                              {row.gst}
                            </StyledTableCell>
                          )}
                          {invoiceSetting.showGstPer_details === "true" && (
                            <StyledTableCell
                              align="center"
                              className={`${styles.list_table_body}`}
                            >
                              {parseFloat(row.gstAmount).toFixed(2)}
                            </StyledTableCell>
                          )}
                          <StyledTableCell
                            align="center"
                            className={`${styles.list_table_body}`}
                          >
                            {parseFloat(row.amount).toFixed(2)}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box style={{ padding: "2px", marginTop: "auto" }}>
            <Grid container spacing={0} sx={{ mt: 2 }}>
              <Grid item xs={8}>
                <Typography
                  className={`${styles.detail_lable}`}
                  sx={{ fontWeight: "bold", paddingBottom: "10px" }}
                >
                  Terms & Conditions
                </Typography>
                {termsDetails.map((row, index) => {
                  if (row.trueFalse) {
                    const trueRows = termsDetails.filter((r) => r.trueFalse);
                    const trueRowIndex = trueRows.indexOf(row);
                    return (
                      <Grid container spacing={0} sx={{ mt: 0 }} key={index}>
                        <Grid item xs={12}>
                          <Box style={{ display: "flex" }}>
                            <Typography
                              className={`${styles.erp_lable}`}
                              style={{ paddingRight: "10px" }}
                            >
                              {trueRowIndex + 1}.{" "}
                            </Typography>
                            <Typography
                              className={`${styles.erp_lable}`}
                              style={{ paddingBottom: "4px" }}
                            >
                              {" "}
                              {row.termsAndConditions}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    );
                  }
                  return null;
                })}
                {/* {(detailsView.remark == '' || detailsView.remark == null || detailsView.remark == undefined) ?
                                    <></>
                                    :
                                    < Typography className={`${styles.detail_lable}`} > <span style={{ fontWeight: 'bold', paddingTop: '10px' }}>Remarks: </span> {detailsView.remark}</Typography>
                                } */}
                <RemarksSection remark={detailsView.remark} />
              </Grid>
              <Grid item xs={4}>
              {invoiceSetting.showGstPer_details === 'true' ?
                  <Grid container spacing={0} sx={{ mt: 0 }}>
                    <Grid
                      item
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        Basic Amount{" "}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        {parseFloat(detailsView.basicTotal).toFixed(2)}
                      </Typography>
                    </Grid>
                
                    <Grid
                      item
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        Assessable Amount
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        {parseFloat(detailsView.assessableAmt).toFixed(2)}
                      </Typography>
                    </Grid>
                    <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            CGST Amount
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.cgstTotal).toFixed(
                              2
                            )}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            SGST Amount
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.sgstTotal).toFixed(
                              2
                            )}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                           IGST Amount
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.igstTotal).toFixed(
                              2
                            )}
                          </Typography>
                        </Grid>
                    {(invoiceSetting.showPackingForwarding === "true" && detailsView.packing_forwarding_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Packing & Forwarding
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.packing_forwarding).toFixed(
                              2
                            )}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {(invoiceSetting.showFreightCharges === "true" && detailsView.freight_charges_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Freight Charges
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.freight_charges).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {(invoiceSetting.showTempoCharges === "true" && detailsView.tempo_charges_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Tempo Charges
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.tempo_charges).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {(invoiceSetting.showOtherCharges === "true" && detailsView.other_charges_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Other Charges
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.other_charges).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    

                    {invoiceSetting.showRoundOff === 'true' ?
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Total Amount{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.total).toFixed(2)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Round off{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.round_off).toFixed(2)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Final Amount{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(Math.round(detailsView.total)).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                      :
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Final Amount{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.total).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    }
                  </Grid>
                  :
                  <Grid container spacing={0} sx={{ mt: 0 }}>
                    <Grid
                      item
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        Basic Amount{" "}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        {parseFloat(detailsView.basicTotal).toFixed(2)}
                      </Typography>
                    </Grid>
                    {(invoiceSetting.showDiscountPer_header === "true" && detailsView.discount_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Discount %
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.totalDiscountPer)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Discount Amount
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.totalDiscountAmt).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}


                    {(invoiceSetting.showPackingForwarding === "true" && detailsView.packing_forwarding_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Packing & Forwarding
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.packing_forwarding).toFixed(
                              2
                            )}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {(invoiceSetting.showFreightCharges === "true" && detailsView.freight_charges_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Freight Charges
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.freight_charges).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {(invoiceSetting.showTempoCharges === "true" && detailsView.tempo_charges_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Tempo Charges
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.tempo_charges).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {(invoiceSetting.showOtherCharges === "true" && detailsView.other_charges_show == 1) && (
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            Other Charges
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.other_charges).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    <Grid
                      item
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        Assessable Amount
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Typography className={`${styles.erp_lable}`}>
                        {parseFloat(detailsView.assessableAmt).toFixed(2)}
                      </Typography>
                    </Grid>

                    {(invoiceSetting.showGstPer_header === "true") && (
                      <>
                        <Grid
                          item
                          xs={2}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            GST %
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.gst)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            GST Amount
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.gstTotal).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    {invoiceSetting.showRoundOff === 'true' ?
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Total Amount{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.total).toFixed(2)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Round off{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.round_off).toFixed(2)}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Final Amount{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(Math.round(detailsView.total)).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                      :
                      <>
                        <Grid
                          item
                          xs={8}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {" "}
                            Final Amount{" "}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Typography className={`${styles.erp_lable}`}>
                            {parseFloat(detailsView.total).toFixed(2)}
                          </Typography>
                        </Grid>
                      </>
                    }
                  </Grid>
                }
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Paper>
      <BootstrapDialog
        PaperProps={{
          sx: {
            maxWidth: "85%",
            height: "95%",
            maxHeight: "98%",
          },
        }}
        onClose={handleClose}
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {openOption === "Update" && "Update Proforma Invoice"}
          {openOption === "Payment" && "Create Customer Payment"}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {openOption === "Update" && (
            <ProformaInvoiceAdd
              handleCloseDialog={handleClose}
              details={detailsView}
              invoiceSettingList={invoiceSettingList}
            />
          )}
          {openOption === "Payment" && <Customer_Supplier_PaymentAdd />}
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
export default ProformaInvoiceDetails;
